module.exports = __webpack_public_path__ + "media/images/og-9ea8a99cb5ee1634eff9288b4e0a2962.png";